/**
 * @generated SignedSource<<59f6be93bee1757518cd6e229e4149a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedUrgencyLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgency_item">;
  readonly " $fragmentType": "PdpSharedUrgencyLazy_item";
};
export type PdpSharedUrgencyLazy_item$key = {
  readonly " $data"?: PdpSharedUrgencyLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgencyLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedUrgencyLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedUrgency_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ebcd2e343efc0a54e4c7d0cbbc7939b2";

export default node;
